import { useLocation } from 'react-router-dom';
import ArchitectChat from '@/components/ArchitectChat';
import { trackEvent } from '@/lib/api';
import { useEffect } from 'react';

export default function AskArchitect() {
  const location = useLocation();
  const context = location.state?.context || null;

  useEffect(() => {
    trackEvent('page_view', { page: 'ask_architect', has_context: !!context });
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen bg-brand-light pt-20" data-testid="ask-architect-page">
      <div className="max-w-2xl mx-auto px-6 py-8">
        <div className="mb-6">
          <p className="text-brand-accent-dark font-heading text-xs font-bold uppercase tracking-[0.2em] mb-2">Architect Guidance</p>
          <h1 className="font-heading text-2xl md:text-3xl tracking-tight font-medium text-brand-dark">
            Ask an Architect
          </h1>
          <p className="text-brand-dark/50 font-body text-sm mt-2 max-w-lg">
            Get clear, professional guidance on architecture in South Africa. Understand your results, explore trade-offs, and prepare better questions for your architect.
          </p>
        </div>
        <ArchitectChat context={context} inline={true} />
        <p className="text-xs text-brand-dark/30 font-body mt-4 text-center">
          AI interprets. Architects decide. This is educational guidance, not professional advice.
        </p>
      </div>
    </div>
  );
}
